import { Directive, HostListener, ElementRef } from '@angular/core';
import { AB_DATE_PREVENT_REGEX } from '../constants';

@Directive({
  selector: '[abDateFormatter]'
})
export class DateFormatterDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.elementRef.nativeElement.value = value.replace(
      new RegExp(AB_DATE_PREVENT_REGEX, 'g'),
      ''
    );
  }
}
